import React, { useContext, useState, useEffect } from 'react';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import LangContext from "../Utils/Lang";
import locale from "../locale.jsx";
import Section from '../Components/Section';
import FileTable from '../Components/FileTable';
import Loader from '../Components/Loader';
import Axios from 'axios';

const PersonalData = () => {
    const { trackPageView } = useMatomo()
    // Track page view
    React.useEffect(() => {
        trackPageView()
    }, [])
    const lang = useContext(LangContext);
    const l = locale[lang];
    const [datalist, setData] = useState({});
    useEffect(() => {
        Axios({
            url: "/data/datacollection.json",
            params: {
                timestamp: (new Date()) * 1
            }
        }).then((res) => {
            if (res && res.data) {
                setData(res.data)
            }
        })
    }, [])
    return (
        <div>
            <Section align="center" title={l.personaldata}>
                {datalist.active ? <FileTable items={datalist.active} /> : <Loader />}
            </Section>
        </div>
    );
};

export default PersonalData;